import { Component, Inject, OnInit, Renderer2 } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { DOCUMENT } from "@angular/common";
import { isDevMode } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

@Component({
    selector: 'app-root',
    template: require('./app.component.html')
})
export class AppComponent implements OnInit {

    private readonly QUALTRICS_ROUTES = ['paymentSuccess', 'guestPaymentSuccess', 'amenities/guestPaymentSuccess'];

    constructor(
        @Inject(WindowToken) private window: Window,
        @Inject(DOCUMENT) private $document: Document,
        @Inject(Renderer2) private renderer: Renderer2,
        @Inject(Router) private router: Router)
    {
    }

    ngOnInit() {
        this.addPrivacyChoiceToHeader();
        this.setupQualtricsListener();
    }

    private setupQualtricsListener() {
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.triggerQualtricsIfNeeded(event.urlAfterRedirects);
        });
    }

    private triggerQualtricsIfNeeded(url: string) {
        if (url && this.QUALTRICS_ROUTES.some(route => url.toLowerCase().includes(route.toLowerCase())) &&
            this.window['loadQualtrics']) {
            // Small delay to ensure page has fully rendered
            setTimeout(() => this.window['loadQualtrics'](), 300);
        }
    }

    private addPrivacyChoiceToHeader() {

        // Load the cookie consent javascript libraries
        const optScript = this.renderer.createElement('script');
        optScript.type = 'text/javascript'
        optScript.innerHTML = 'function OptanonWrapper() {}'

        const consentScript = this.renderer.createElement('script');
        consentScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        consentScript.type = 'text/javascript';
        consentScript.charset = 'UTF-8';

        if(isDevMode){
            consentScript.setAttribute('data-domain-script','73b90cc8-385b-4f54-8f21-461a790b4365-test');
        } else {
            consentScript.setAttribute('data-domain-script','73b90cc8-385b-4f54-8f21-461a790b4365');
        }

        this.renderer.appendChild(this.$document.head, this.renderer.createComment('OneTrust Cookies Consent Notice start for firstcitizens.com'))
        this.renderer.appendChild(this.$document.head, consentScript);
        this.renderer.appendChild(this.$document.head, optScript);
        this.renderer.appendChild(this.$document.head, this.renderer.createComment('OneTrust Cookies Consent Notice end for firstcitizens.com'))

    }
}
